<template>
  <div>
    <div v-show="window.size.mobile && !hideSwiper" id="sticky-swiper"
         ref="statsFilter"
         :class="{ 'shadow-zt' : isFilteringSticky, '!z-0' : !isFilteringSticky }"
         class="border-t border-zt-light py-3 sticky top-0 z-10 bg-zt-main" >
      <div id="swiper-leagues" class="swiper">
        <div class="swiper-wrapper pl-2">
          <div v-for="(tab, index) in highlightedLeaguesIds"
               @click="changeTab(tab.short_title, index, false)"
               :class="{ 'bg-zt-light font-semibold'  : tab.short_title === selectedStat, 'mr-4'
               : index === highlightedLeaguesIds.length - 1}"
               class="swiper-slide w-fit text-xs p-2  border border-zt-light rounded-[15px]">
            {{ tab.short_title }}
          </div>
        </div>
      </div>
    </div>
    <div v-for="(league, index) in highlightedLeaguesIds" :id="'table-'+stringToId(league.short_title)+index">
      <RefereeDetailsTable
          :league-id="league.league_id"
          :only-referees="true"/>
    </div>
  </div>
</template>

<script>
import RefereeDetailsTable from "../components/football_stats/tables/RefereeDetailsTable.vue";
import {stickyFollowHeader, stringToId} from "../../assets/js/utils";
import Swiper from "swiper";
import {FreeMode, Scrollbar} from "swiper/modules";
export default {
  name: "RefereeStatsPage",
  inject: ['WP'],
  components: {
    RefereeDetailsTable
  },
  data() {
    return {
      highlightedLeaguesIds: [
        {
          league_id: 39,
          short_title: 'Anglia'
        },
        {
          league_id: 61,
          short_title: 'Francja'
        },
        {
          league_id: 140,
          short_title: 'Hiszpania'
        },
        {
          league_id: 88,
          short_title: 'Holandia'
        },
        {
          league_id: 78,
          short_title: 'Niemcy'
        },
        {
          league_id: 106,
          short_title: 'Polska'
        },
        {
          league_id: 135,
          short_title: 'Włochy'
        },
      ],
      isFilteringSticky: false,
      hideSwiper: false,
      selectedStat: '',
      elemsPositions: [],
      highlightedLeaguesIdsCopy: [],
    }
  },
  mounted() {
    this.highlightedLeaguesIdsCopy = this.highlightedLeaguesIds.slice();
    setTimeout(async () => {
      this.initializeSwiper();
      this.stickyFollowHeader('sticky-swiper', this.WP.user.adminBar);
      this.getTablesPositions();
      this.observeStatsFilter();
      window.addEventListener('scroll', this.onScrollHandler);
    },1000)
    this.removePlaceholder('sedziowie');
  },
  methods: {
    changeTab(tab, index, isHidden = false) {
      if (isHidden) {
        return;
      }
      this.changeTabWithoutScroll(tab);
      this.disabledObserver = true;
      let extraOff = WP.user.adminBar ? -32 : 0;
      if (index < this.lastIndex) {
        extraOff -= window.mainHeaderHeight;
      }
      const yOffset = -59 + extraOff;
      const element = document.querySelector(`[id*="table-${stringToId(tab)}"]`);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
      this.lastIndex = index;
      setTimeout(() => {
        this.disabledObserver = false;
      }, 1000);
    },
    changeTabWithoutScroll(tab) {
      if (this.disabledObserver) {
        return;
      }
      const index = this.highlightedLeaguesIds.findIndex(option => option.short_title === tab);
      this.selectedStat = tab;
      this.swiper.slideTo(index, 500, false);
    },
    stringToId,
    stickyFollowHeader,
    initializeSwiper() {
      this.swiper = new Swiper('#swiper-leagues', {
        modules: [ Scrollbar, FreeMode ],
        slidesPerView: 'auto',
        resistanceRatio: 0,
        centeredSlides: window.size.mobile,
        centeredSlidesBounds: true,
        freeMode: {
          enabled: true,
          minimumVelocity: 0.01,
          momentum: true,
          momentumBounce: false,
          momentumRatio: 0.7,
          momentumVelocityRatio: 0.5,
          sticky: false,
        },
        spaceBetween: 6,
      });
    },
    observeStatsFilter() {
      const stickyObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.intersectionRatio < 1) {
                this.isFilteringSticky = true;
              }
            });
          },
          {
            threshold: 1,
            rootMargin: `${WP.user.adminBar ? '-32' : '0'}px 0px 0px 0px`,
          }
      );
      const staticObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.intersectionRatio >= 1) {
                this.isFilteringSticky = false;
              }
            });
          },
          {
            threshold: 1,
            rootMargin: `${WP.user.adminBar ? '-98' : '-66'}px 0px 0px 0px`,
          }
      );
      staticObserver.observe(this.$refs.statsFilter);
      stickyObserver.observe(this.$refs.statsFilter);
    },
    getTablesPositions() {
      const allPositions = [];
      const copy = this.highlightedLeaguesIds.slice();
      for (let table of copy) {
        const elems = document.querySelectorAll(`[id*="table-${stringToId(table.short_title)}"]`);
        if (elems.length === 0) {
          this.highlightedLeaguesIdsCopy.splice(this.highlightedLeaguesIdsCopy.findIndex(item => item.short_title === table.short_title), 1);
        }
        for (let elem of elems) {
          let extraOff = WP.user.adminBar ? -32 : 0;
          const yOffset = -59 + extraOff;
          const y = elem.getBoundingClientRect().top + window.pageYOffset + yOffset;
          allPositions.push({
            pos: y,
            height: elem.offsetHeight,
            name: table.short_title
          })
        }
      }
      this.elemsPositions = allPositions;
    },
    onScrollHandler() {
      if (this.disabledObserver) {
        return;
      }
      const scrollPos = window.scrollY;
      let scrollVal = scrollPos;
      let index = 0;

      if (scrollPos < this.lastScrollPos) {
        scrollVal += 200;
      }

      for (let i = 1; i < this.elemsPositions.length; i++) {
        if (scrollVal > this.elemsPositions[i].pos) {
          index = i;
        }	else {
          break;
        }
      }
      this.lastStatIndex = index;
      this.lastScrollPos = scrollPos;
      this.debounce(() => {
        this.changeTabWithoutScroll(this.highlightedLeaguesIdsCopy[index].short_title);
      }, 50);
    },
    debounce(fn, delay) {
      let timer;
      return (() => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(), delay);
      })();
    },
  },
  computed: {
  }
}
</script>

<style>

</style>